import { render, staticRenderFns } from "./TemplateKlasse.vue?vue&type=template&id=3a327342&"
import script from "./TemplateKlasse.vue?vue&type=script&lang=js&"
export * from "./TemplateKlasse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports